import React from 'react'
import ReceiptIcon from '@mui/icons-material/Receipt';
import { Tooltip } from '@mui/material'
import { useState } from 'react';
import { useEffect } from 'react';

const SupplyBillNakladnaItemsShort = ({ supplyBill }) => {

	const [nakladnaText, setNakladnaText] = useState('')

	useEffect(() => {
		if (supplyBill) {
			let temp = ''
			if (supplyBill.isNakladna) {
				temp += '+/'
			} else {
				temp += '-/'
			}
			if (supplyBill.isNakladnaOriginal) {
				temp += '+'
			} else {
				temp += '-'
			}

			setNakladnaText(temp)
		}
	}, [supplyBill])

  return (
    <div className='commentShortOne'>
        <Tooltip title='Накладна/Оригінал накладної'>
            <ReceiptIcon />
        </Tooltip>
        <p>
            {
                // supplyBill && supplyBill.isNakladna ? '+' : '-'
				nakladnaText
            }
        </p>
    </div>
  )
}

export default SupplyBillNakladnaItemsShort